import React from "react";
import ReactDOM from "react-dom";

import NextApp from './NextApp';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
// Add this import:
import { AppContainer } from 'react-hot-loader';


// Add styles
const styles = `
  .ant-card.gx-card-metrics .ant-card-head {
    background: #1890ff;
    border-radius: 8px 8px 0 0;
    // margin: 0 16px;
    // padding: 8px 16px;
    border: 1px solid #e8e8e8;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    min-height: 48px;
    display: flex;
    align-items: center;
  }

  .ant-card.gx-card-metrics .ant-card-head-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .ant-card.gx-card-metrics .ant-card-head-title {
    color: #ffffff;
    font-weight: 500;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .ant-card.gx-card-metrics .ant-card-body {
    padding-top: 24px;
  }

  .dark-theme .ant-card.gx-card-metrics .ant-card-head {
    background: #3b4550;
    border: 1px solid #44515b;
    box-shadow: 0 2px 4px rgba(0,0,0,0.25);
  }

  .dark-theme .ant-card.gx-card-metrics .ant-card-head-title {
    color: #e5e7eb;
  }
`;

// Create style element
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// Wrap the rendering in a function:
const render = Component => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <AppContainer>
      <NextApp />
    </AppContainer>,
    document.getElementById('root')
  );
};

// No service worker: it kept serving the previous build after a deploy. This removes the one
// already installed in users' browsers; nginx cache headers decide what is cached instead.
unregisterServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
